module.exports = __webpack_public_path__ + "static/media/aww_maaan1.80d864bc.wav";